import { Helmet } from "react-helmet";
import Authority from "../../components/reusables/Authority";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import SolutionCTAUndefined from "../../components/solutions/SolutionCTAUndefined";
import ICTTrainingFaqsBody from "../../components/faqs/ICTTrainingFaqsBody";
import ICTTraining from "../../components/solutions/icttraining/ICTTraining";
import RelatedICTTraining from "../../components/solutions/icttraining/RelatedICTTraining";

export default function ICTTrainingSchool() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/ict-training"
        />
        <meta
          name="description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT Training & Capacity Building."
        />
        
        <meta
          property="og:description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT Training & Capacity Building."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | ICT Training & Capacity Building | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | ICT Training & Capacity Building | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | ICT Training & Capacity Building | Uganda"
        />
        <meta
          name="twitter:description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT Training & Capacity Building."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | Solutions | ICT Training & Capacity Building | Uganda
        </title>
      </Helmet>
      <SolutionItemHero
        title="ICT Training & Capacity Building"
        subtitle="Build practical ICT & AI skills for life through structured learning packages at The Uganda School of ICT. Designed for real-world application, fast income generation and career growth."
        casestudylink="/#"
        CTAtext="Enroll Now"
        mainCTAlink="https://ict.ug"
      />
      <Authority />
      <ICTTraining />
      <SolutionCTAUndefined
        ctaTitle="Ready To Build Practical ICT & AI Skills for Life at The Uganda School of ICT?"
        CTAlink="https://ict.ug"
        CTAtext="Enroll Now"
      />
      <ICTTrainingFaqsBody />
      <SolutionCTAUndefined
        ctaTitle="Ready To Build Practical ICT & AI Skills for Life at The Uganda School of ICT?"
        CTAlink="https://ict.ug"
        CTAtext="Enroll Now"
      />
      <RelatedICTTraining />
    </>
  );
}
